import { useState, useEffect } from 'react';

const ALERTS_URL = 'https://n293vk0zm6.execute-api.us-east-1.amazonaws.com/prod/alerts';
const TRACKS_URL = 'https://n293vk0zm6.execute-api.us-east-1.amazonaws.com/prod/tracks';

export default function useChartData() {
  const [alerts, setAlerts]               = useState([]);
  const [allAlerts, setAllAlerts]         = useState([]);
  const [snapshotCount, setSnapshotCount] = useState(null);
  const [todayCount, setTodayCount]       = useState(null);
  const [loading, setLoading]             = useState(true);
  const [error, setError]                 = useState(null);

  useEffect(() => {
    async function fetchAlerts() {
      try {
        const res  = await fetch(ALERTS_URL);
        const data = await res.json();
        const items = Array.isArray(data) ? data : (data.alerts || data.items || []);
        setAlerts(items);
        if (data.snapshot_count !== undefined) {
          setSnapshotCount(data.snapshot_count);
        }
        if (data.today_count !== undefined) {
          setTodayCount(data.today_count);
        }
      } catch (err) {
        setAlerts([]);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }

    async function fetchAllAlerts() {
      try {
        const res  = await fetch(ALERTS_URL + '?all=true&unfiltered=true');
        const data = await res.json();
        setAllAlerts(data.alerts || []);
        console.log('allAlerts loaded:', data.alerts?.length, data.alerts?.map(a => a.detected_date + ' ' + a.name));
      } catch {
        setAllAlerts([]);
      }
    }

    fetchAlerts();
    fetchAllAlerts();
  }, []);

  return { alerts, allAlerts, snapshotCount, todayCount, loading, error, TRACKS_URL };
}